/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Detail_ExpandedInputs */

const en_landing_studio_detail_expanded = /** @type {(inputs: Landing_Studio_Detail_ExpandedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expanded`)
};

const zh_landing_studio_detail_expanded = /** @type {(inputs: Landing_Studio_Detail_ExpandedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扩写`)
};

/**
* | output |
* | --- |
* | "Expanded" |
*
* @param {Landing_Studio_Detail_ExpandedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_detail_expanded = /** @type {((inputs?: Landing_Studio_Detail_ExpandedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Detail_ExpandedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_detail_expanded(inputs)
	return zh_landing_studio_detail_expanded(inputs)
});
export { landing_studio_detail_expanded as "landing.studio.detail_expanded" }